<template>
    <div>
        <el-button @click="add" v-show="(value || []).length < 1">
            添加
        </el-button>
        <MultiInput
            :items="props.inputItems"
            :maxCount="props.maxCount"
            :minCount="props.minCount"
            :value="value || []"
            @change="changeHandler($event)"
        />
        <div class="error-msg" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
</template>

<script>
import MultiInput from "@/views/zhiji/components/multiInput/index.vue";

export default {
    name: "MultiInputs",
    components: {
        MultiInput
    },
    props: ["value", "widget", "verifyInfo", "rules", "validation"],
    computed: {
        props() {
            return this.widget.props;
        },
        errorMessage() {
            let message = "";
            const hasError = (this.verifyInfo.items || []).some(item => {
                // eslint-disable-next-line guard-for-in
                for (const prop in item) {
                    if (item[prop]) {
                        message = item[prop].message;
                        return true;
                    }
                }
            });
            return hasError ? message : "";
        }
    },
    created() {
        const { minCount } = this.widget.props;
        if (minCount && (this.value || []).length < minCount) {
            for (let i = 0; i < minCount; ++i) {
                setTimeout(() => this.add(), 15);
            }
        }
    },
    methods: {
        changeHandler(newValue) {
            this.$emit("change", newValue);
            this.verifyHandler();
        },
        add() {
            this.$emit("change", [...(this.value || []), {}]);
            this.verifyRequired();
        },
        verifyHandler() {
            console.log(this.verifyInfo);
        },
        verifyRequired() {
            if (!this.rules.some(rule => rule.required)) {
                return;
            }

            this.$emit("verify", { isValid: true, message: "" });
        }
    }
};
</script>

<style scoped lang="less">
/deep/ .multi-input-item-wrapper {
    height: 40px;
}
.error-msg {
    color: #f33535;
}
</style>
